import { tv, VariantProps } from 'tailwind-variants';

const paraVariants = tv({
  base: 'antialiased',
  variants: {
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
      '6xl': 'text-6xl',
      '7xl': 'text-7xl',
      '8xl': 'text-8xl',
      '9xl': 'text-9xl',
    },
    weight: {
      thin: 'font-thin font-aribau',
      light: 'font-light font-aribau',
      normal: 'font-normal font-aribau',
      medium: 'font-semibold font-aribau',
      bold: 'font-aribaubold',
      extrabold: 'font-bold font-aribaubold',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
    pretty: {
      true: 'text-pretty',
    },
  },
  defaultVariants: {
    size: 'base',
    weight: 'normal',
  },
});

interface ParaProps<T extends React.ElementType> extends VariantProps<typeof paraVariants> {
  as?: T;
  children?: React.ReactNode;
}

export function Para<T extends React.ElementType = 'p'>({
  as,
  children,
  weight,
  pretty,
  size,
  align,
  ...props
}: ParaProps<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof ParaProps<T>>): JSX.Element {
  const Component = as || 'p';

  const newClassNames = paraVariants({ ...props, align, size, weight, pretty });

  return (
    <Component {...props} className={newClassNames}>
      {children}
    </Component>
  );
}
